
import {Content} from "antd/es/layout/layout";
import {Checkbox, Select, Spin, Typography} from "antd";
import React, {useState} from "react";
import {useWellsGeothermal} from "../../hooks/useWellsGeothermal";
import {BarChartUsageExample} from "../DemoBar/DemoBar";

const countryList = [
		{ value: '', label: 'All' },
		{ value: 'Montserrat', label: 'Montserrat' },
		// Add more countries as needed
];

const WellsGeothermal = () => {
		const {data, calculatedData, loading, setData, fetchData, setIsSum, isSum} = useWellsGeothermal();
		const [location , setLocation] = useState<string>("");
				return (
					<Content style={{
							padding: '0 24px',
							height: '100%',
							display: "flex",
							flexDirection: "column",
							overflow: 'auto'
					}}>
							<h1 style={{ color: 'var(--navy)', fontSize: '28px', fontWeight: 700, margin: '24px 0 16px', width: '100%', textAlign: 'left' }}>Geothermal Market Size</h1>

							{/* Controls panel */}
							<div className="va-controls-panel">
								<div className="va-control-group">
									<span className="va-control-label">Wells Summary</span>
									<Checkbox
										value={isSum}
										onChange={(e) => {
												setIsSum(!isSum);
										}}
									>
											Well`s summary
									</Checkbox>
								</div>
								<div className="va-control-group">
									<span className="va-control-label">Location</span>
									<Select
										defaultValue={''}
										value={location}
										onChange={(value) => {
												setLocation(value);
												fetchData(value);
										}}
										options={countryList}
									/>
								</div>
							</div>

							{/* Chart */}
							<Spin spinning={loading} size="large" style={{width: '100%'}}>
							<div className="chart-frame">
								{calculatedData &&
								<BarChartUsageExample chartData={calculatedData}/>}
							</div>
							</Spin>

							<Typography.Text style={{alignSelf: "start", color: "var(--muted)", padding: "0 0 24px"}}>
									⁃ Data on the commodities&apos; average prices is taken from the USGS Commodities Summary 2024.
									<br/>
									⁃ Data on the element concentration in geothermal wells is taken from the Argonne Database.
									<br/>
									⁃ The production rate of 100000 Mt per day is assumed.
									<br/>
									⁃ 100% recovery rate is assumed in these calculations.
							</Typography.Text>
					</Content>
				);
		}
export default WellsGeothermal;